import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime-picker';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledDiv = styledComponent('div', {
  '& .react-datetime-picker__button': {
    border: theme.borders.input,
    borderRadius: theme.radii.input,
    padding: theme.spacing.datePickerInnerPadding,
    background: theme.colors.bgCard,
    transition: theme.transitions.default,
    minHeight: theme.sizes.inputMinHeight,
    width: '100%',
  },
  '& .react-datetime-picker__button:hover': {
    borderColor: theme.colors.focusRing,
  },
  '& .react-datetime-picker__button:focus-within': {
    outline: 'none',
    borderColor: theme.colors.focusRing,
    boxShadow: `0 0 0 2px ${theme.colors.focusRing}33`,
  },
  '& .react-datetime-picker__button__input': {
    padding: theme.spacing.datePickerInputPadding,
  },
  '& .react-datetime-picker__button__input__input': {
    ...theme.typography.label,
    color: theme.colors.textBody,
  },
  '& .react-datetime-picker__button__icon': {
    padding: theme.spacing.iconPadding,
  },
  '& .react-datetime-picker__button__icon svg': {
    width: theme.sizes.icon,
    height: theme.sizes.icon,
    stroke: theme.colors.textHint,
  },
  '& .react-datetime-picker__button__icon svg g': {
    stroke: theme.colors.textHint,
  },
  '& .react-datetime-picker__button__icon:enabled:hover svg, & .react-datetime-picker__button__icon:enabled:focus svg':
    {
      stroke: theme.colors.focusRing,
    },
  '& .react-datetime-picker__button__icon:enabled:hover svg g, & .react-datetime-picker__button__icon:enabled:focus svg g':
    {
      stroke: theme.colors.focusRing,
    },
});

function DateTimeField({ value, onChange, disabled, disableClock, minDate }) {
  return (
    <StyledDiv>
      <DateTimePicker
        value={value}
        onChange={onChange}
        disabled={disabled}
        disableClock={disableClock}
        minDate={minDate}
      />
    </StyledDiv>
  );
}

DateTimeField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disableClock: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
};

DateTimeField.defaultProps = {
  value: null,
  disabled: false,
  disableClock: true,
  minDate: undefined,
};

export default DateTimeField;
